import { EmptyState } from './EmptyState';

interface ErrorStateProps {
  message?: string;
  onRetry?: () => void;
}

export function ErrorState({ message, onRetry }: ErrorStateProps) {
  return (
    <EmptyState
      icon="⚠"
      title="Erreur"
      description={message || 'Une erreur est survenue.'}
      action={onRetry ? { label: 'Réessayer', onClick: onRetry } : undefined}
    />
  );
}
